import { useState, useEffect } from 'react';
import API from '../../../services/API';
import { useParams } from 'react-router-dom/cjs/react-router-dom';
import { Space, Row, Col, Divider } from 'antd';
import Data from '../../CustomText/data';
import { convertCentsIntoDollar, formatUTCDate } from '../../../helpers/genericHelper';
import BloomData from './BloomData';

export default function RentReportingComponent({ }) {

  const { userId } = useParams();
  const [rentData, setRentData] = useState(null);

  const getRentReportingData = async () => {
    const data = await API.getRentReporting({ userId });
    console.log('rent', data)
    setRentData(data);
  }

  useEffect(() => {
    getRentReportingData();
  }, []);

  if (!rentData) {
    return <>
      <Row justify="center">
        <Col span="4">
          <Data title="Enrollment Status" value="Not Enrolled" />
        </Col>
      </Row>
    </>
  }

  const { updateTs, createTs, rentReportingUser, experienceType, bloomData } = rentData;
  const { customer, plaid } = rentReportingUser || {};

  // Check if this is the new 2.0 type with bloomData
  const isRR20 = experienceType === "RR_2_0" && !rentReportingUser && bloomData;

  const rentalVerificationStatus = (rentalVerification) => {
    return `For ${rentalVerification.for_month}: ${rentalVerification.status}`;
  }

  return (<>
    {
      rentData && (
        <>
          {isRR20 ? (
            <>
              <div style={{ textAlign: 'center', marginBottom: '20px', padding: '15px' }}>
                <strong>Experience Type: RR2 (Bloom)</strong>
              </div>
              <BloomData bloomData={bloomData} createTs={createTs} updateTs={updateTs} userId={userId} />
            </>
          ) : (
            <>
              <div style={{ textAlign: 'center', marginBottom: '20px', padding: '15px' }}>
                <strong>Experience Type: RR1.2 (BoomPay)</strong>
              </div>
              <Space direction='vertical' style={{ width: '100%' }}>
                <Row justify="center">
                  <Col span="5">
                    <Data title="Enrollment Status" value={customer?.enrollment?.enrollmentStatus} />
                  </Col>
                  <Col span="4">
                    <Data title="Created" value={formatUTCDate(createTs, true)} />
                  </Col>
                  <Col span="4">
                    <Data title="Updated" value={updateTs ? formatUTCDate(updateTs, true) : null} />
                  </Col>
                </Row>
                <Divider />
                <Row justify="center">
                  <Col span="4">
                    <Data title="Partner Token ID" value={plaid?.partnerPlaidTokenId?.value} copyable />
                  </Col>
                  <Col span="4">
                    <Data title="Partner Enrollment ID" value={customer?.enrollment?.partnerEnrollmentId?.value} copyable />
                  </Col>
                  <Col span="4">
                    <Data title="Partner Customer ID" value={customer?.id?.value} copyable />
                  </Col>
                  <Col span="4">
                    <Data title="Token Posted At" value={formatUTCDate(plaid?.plaidTokenPostedAt, true)} />
                  </Col>
                  <Col span="4">
                    <Data title="Plaid Account ID" value={plaid?.plaidAccountsId} copyable />
                  </Col>
                </Row>
                <Divider />
                <Row justify="space-between">
                  <Col span="2">&nbsp;</Col>
                  <Col span="4">
                    <Data title="Monthly Rent" value={customer?.enrollment?.monthlyRentCents ? convertCentsIntoDollar(customer?.enrollment?.monthlyRentCents) : null} />
                  </Col>
                  <Col span="4">
                    <Data title="Monthly Rent (Day of Month)" value={customer?.enrollment?.monthlyRentDayOfMonth} />
                  </Col>
                  <Col span="4">
                    <Data title="Lease End Date" value={customer?.enrollment?.leaseEndDate ? formatUTCDate(customer?.enrollment?.leaseEndDate) : null} />
                  </Col>
                  <Col span="4">
                    <Data title="Lease Month to Month" value={customer?.enrollment?.leaseMonthToMonth} />
                  </Col>
                  <Col span="2">&nbsp;</Col>
                </Row>
                <Divider />
                <Row justify="center">
                  <Col span="8">
                    <Data title="One Line Address" value={customer?.enrollment?.oneLineAddress} copyable />
                  </Col>
                  <Col span="4">
                    <Data title="Move In Date" value={customer?.enrollment?.moveInDate ? formatUTCDate(customer?.enrollment?.moveInDate) : null} />
                  </Col>
                  <Col span="4">
                    <Data title="Checkout Out" value={`${customer?.enrollment?.checkedOut}`} />
                  </Col>
                </Row>
                <Divider />
                <Row justify="space-between">
                  <Col span="2">&nbsp;</Col>
                  <Col span="4">
                    <Data title="Issues" value={customer?.enrollment?.issues} list />
                  </Col>
                  <Col span="4">
                    <Data title="Verifications" value={customer?.enrollment?.rentalVerifications?.map(rentalVerificationStatus)} list />
                  </Col>
                  <Col span="2">&nbsp;</Col>
                </Row>
              </Space>
            </>
          )}
        </>)
    }
  </>);
}